function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("title", null, "background"), React.createElement("rect", {
  fill: "none",
  id: "canvas_background",
  height: 92,
  width: 74,
  y: -1,
  x: -1
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("title", null, "Layer 1"), React.createElement("path", {
  id: "svg_1",
  d: "m35.931884,0.378261c-10.8,0 -19.6,8.8 -19.6,19.6s8.8,19.6 19.6,19.6s19.6,-8.8 19.6,-19.6s-8.8,-19.6 -19.6,-19.6z"
}), React.createElement("path", {
  id: "svg_2",
  d: "m54.031884,46.578261l-36.2,0c-9.3,0 -17.1,7.5 -17.1,17.1l0,15.8l18.5,0c-0.7,-1.9 -1.2,-4 -1.2,-6.1c0,-9.5 8,-17.3 17.8,-17.3s17.8,7.7 17.8,17.3c0,2.2 -0.4,4.2 -1.2,6.1l18.5,0l0,-15.8c0.2,-9.6 -7.3,-17.1 -16.9,-17.1z"
}), React.createElement("path", {
  id: "svg_3",
  d: "m35.931884,59.178261c-7.8,0 -14.2,6.3 -14.2,14.2c0,7.8 6.3,14.2 14.2,14.2s14.2,-6.3 14.2,-14.2c0,-7.8 -6.4,-14.2 -14.2,-14.2zm-2,20l-5.7,-5.6l2.2,-2.2l3.5,3.5l7.3,-7.3l2.2,2.2l-9.5,9.4z"
}));

var SvgVoute = function SvgVoute(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "72mm",
    height: "90mm",
    viewBox: "0 0 72 90",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgVoute, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/voute.435f6cbc.svg";
export { ForwardRef as ReactComponent };